/** Página Product: todo lo que hace Finance 360, en seis áreas con pantallas reales. */
import { Link } from 'react-router-dom';
import Marco, { Navegacion, useMeta } from './Marco';
import { useT } from './idioma';
import { Ventana } from './Inicio';

const Puntos = ({ lista }) => (
  <ul className="puntos" style={{ marginTop: 32 }}>{lista.map(([b, s]) => <li key={b}><div><b>{b}</b><span>{s}</span></div></li>)}</ul>
);

function Area({ id, area, clips, videos, invertido, noche }) {
  const texto = (
    <div className="texto">
      <div className="mono" style={{ fontSize: 13, color: noche ? '#8E98F0' : '#4652B8' }}>{area.n}</div>
      <h2 className="display h3" style={{ color: noche ? '#fff' : '#1A1D4E', margin: '14px 0 0', lineHeight: 1.06 }}>{area.titulo}</h2>
      <Puntos lista={area.puntos} />
    </div>
  );
  const medio = (
    <div className="medio" style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
      {clips.map((c, n) => (
        <div key={c} style={n ? { width: '78%', alignSelf: invertido ? 'flex-start' : 'flex-end' } : undefined}>
          <Ventana clip={c} etiqueta={videos[c]} />
        </div>
      ))}
      {area.nota && <div className="mono" style={{ fontSize: 12, color: '#AEB4DD' }}>{area.nota}</div>}
    </div>
  );
  return (
    <section id={id} className={noche ? 'noche' : ''} style={noche ? { marginTop: 140 } : undefined}>
      <div className="caja dos" style={{ paddingTop: noche ? 130 : 140, paddingBottom: noche ? 130 : 0, flexWrap: invertido ? 'wrap-reverse' : 'wrap' }}>
        {invertido ? <>{medio}{texto}</> : <>{texto}{medio}</>}
      </div>
    </section>
  );
}

export default function Producto() {
  const T = useT();
  const t = T.producto;
  useMeta(T.meta.producto);
  return (
    <Marco>
      <header className="noche">
        <Navegacion tono="oscura" />
        <div className="caja" style={{ paddingTop: 96, paddingBottom: 110 }}>
          <div className="ojo">{t.ojo}</div>
          <h1 className="display" style={{ fontSize: 'clamp(44px,6vw,88px)', lineHeight: 1, margin: '18px 0 0', maxWidth: 1000 }}>{t.titulo}</h1>
          <p className="suave" style={{ fontSize: 20, margin: '26px 0 0', maxWidth: 680 }}>{t.bajada}</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 44 }}>
            {t.saltos.map(([id, nombre]) => <a key={id} href={`#${id}`} className="pildora borde" style={{ minHeight: 44, fontSize: 15 }}>{nombre}</a>)}
          </div>
        </div>
      </header>

      <Area id="invoicing" area={t.areas.invoicing} clips={['invoice', 'payables']} videos={t.videos} />
      <Area id="ai" area={t.areas.ai} clips={['ai']} videos={t.videos} invertido noche />
      <Area id="taxes" area={t.areas.taxes} clips={['tax']} videos={t.videos} />
      <Area id="reports" area={t.areas.reports} clips={['statements', 'reports']} videos={t.videos} invertido />
      <Area id="control" area={t.areas.control} clips={['budget']} videos={t.videos} />

      <section id="platform">
        <div className="caja" style={{ paddingTop: 140, paddingBottom: 140 }}>
          <div className="mono" style={{ fontSize: 13, color: '#4652B8' }}>{t.plataforma.n}</div>
          <h2 className="display h3" style={{ color: '#1A1D4E', margin: '14px 0 0', maxWidth: 820, lineHeight: 1.06 }}>{t.plataforma.titulo}</h2>
          <div className="tres" style={{ marginTop: 56 }}>
            {t.plataforma.puntos.map(([b, s]) => (
              <div key={b} style={{ flexBasis: 300, borderBottom: '1px solid #E2E5EF' }}>
                <div style={{ fontWeight: 600, color: '#1A1D4E' }}>{b}</div>
                <p className="suave" style={{ margin: '6px 0 0' }}>{s}</p>
              </div>
            ))}
          </div>
          <div className="noche" style={{ marginTop: 72, display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center', justifyContent: 'space-between', borderRadius: 24, padding: 48 }}>
            <h2 className="display" style={{ fontSize: 'clamp(28px,3vw,40px)' }}>{t.cta}</h2>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              <Link to="/demo" className="pildora primaria">{T.nav.demo}</Link>
              <Link to="/pricing" className="pildora borde">{t.verPrecios}</Link>
            </div>
          </div>
        </div>
      </section>
    </Marco>
  );
}
